import { keyframes } from '@emotion/react';
import { Spinner } from '@mos-cat/ds-icons';
import { Box } from '../../../../Box/Box';
import { Text } from '../../../../Text/Text';

const spin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(359deg)' },
});

export function LoadingIndicator() {
  return (
    <Box
      as={Text}
      size="fileUploaderSpinnerSize"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      color="fileUploaderLoadingIndicatorColor"
      flexShrink={0}
      mt="fileUploaderIconTopOffset"
    >
      <Box
        as={Spinner}
        size={1}
        styles={{
          animation: `${spin} .75s linear 0s infinite normal none running`,
        }}
      />
    </Box>
  );
}
